module.exports = __webpack_public_path__ + "img/2Recruit2.8b7861e9.png";